export const realThreshold = 1e-8;

export const rtDigits = 8;
